import forOwn from 'mout/object/forOwn'

/**
 * Initializes the byNode scoring object
 * @param {object} items All items in db.collection('contentItems').
 * @param {object} destructuredSubtests Contains arrays of items for each subtest.
 * @returns {object} The byNode scoring object.
 */
export default function initializeByNodeScoring(items, destructuredSubtests) {
  let byNode = {}
  forOwn(destructuredSubtests, (subtest, key, o) => {
    byNode[key] = {}
    subtest.items.forEach((itemId) => {
      const nodeTagObj = items[itemId].nodeTags
      if (nodeTagObj) {
        forOwn(nodeTagObj, (bool, nodeTagId, ob) => {
          if (bool) {
            if (byNode[key][nodeTagId]) {
              let itemsList = byNode[key][nodeTagId].items.slice(0)
              itemsList.push(itemId)
              byNode[key][nodeTagId] = {
                ...byNode[key][nodeTagId],
                possible: byNode[key][nodeTagId].possible + 1,
                items: itemsList,
              }
            } else {
              byNode[key][nodeTagId] = {
                possible: 1,
                raw: 0,
                percentage: 0,
                items: [itemId]
              }
            }
          }
        })
      }

    })
  })
  return byNode
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/initializeByNodeScoring.js